export const RED = '#A31420';

export const ERROR_STYLE = __DEV__
  ? {
      borderColor: RED,
      backgroundColor: 'rgba(163, 20, 32, 0.4)',
      borderWidth: 4,
    }
  : null;
